import React from 'react';
import { ArrowRightOutlined } from '@ant-design/icons';
import useReveal from '../useReveal';
import './AIEEconomics.css';

/**
 * AIEEconomics: the economics beat, B3 design (Nitish ruling Sep 2 2026, live).
 * Statement left with the CTA, two claims right, each a figure plus one line.
 * The salary-comparison tile and its heading are retired (we compare with
 * nothing). Two claims only: under a minute to hire, free to try (Sep 6 2026
 * ruling: no cost figure on this page; figures live in the four pricing homes,
 * see src/content/pricingFigures.json).
 * Retired pricing vocabulary stays off the page. Mock record:
 * work/aie_econ_control/build_econ2b.py (Maeve's workspace).
 */
const CLAIMS = [
  { value: 'Under a minute', label: 'Describe the role. They start.' },
  { value: 'Free to try', label: 'No credit card. Pay only for the work.' },
];

const AIEEconomics = ({ ctaLabel, onPrimary }) => {
  const [ref, visible] = useReveal();

  return (
    <section className="aie-econ aie-section">
      <div className="aie-econ__grid">
        <div className="aie-econ__lead">
          <span className="aie-eyebrow">The economics</span>
          <h2 className="aie-section-title aie-display">
            Try one before you decide anything.
          </h2>
          <p className="aie-section-sub">
            Free to try. You pay only for the work they do.
          </p>
          <div className="aie-econ__cta">
            <button
              type="button"
              data-msc-suppress
              className="aie-btn aie-btn-primary"
              onClick={onPrimary}
            >
              {ctaLabel}
              <ArrowRightOutlined />
            </button>
            <div className="aie-econ__support">Try it free, no credit card needed</div>
          </div>
        </div>
        <div className={`aie-econ__claims aie-reveal ${visible ? 'is-visible' : ''}`} ref={ref}>
          {CLAIMS.map((c) => (
            <div className="aie-econ__claim" key={c.value}>
              <div className="aie-econ__value">{c.value}</div>
              <div className="aie-econ__label">{c.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AIEEconomics;
